import { useEffect, useMemo, useState } from "react";
import { createContext } from "react";
import { getCookie } from "../utils/cookieHelper";

export const UserContext = createContext({});

/**
 * @param {*} param0
 * @returns <UserContext.Provider/>
 * @returns <UserContext.Consumer/>
 *
 */
function UserContextProvider({ children }) {
  const [user, setUser] = useState(() => {
    const storedUser = window.localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [token, setToken] = useState(() => getCookie("token") || null);

  const getUser = () => user;

  useEffect(() => {
    if (user) {
      // Mettre à jour localStorage lorsque le `user` change
      window.localStorage.setItem("user", JSON.stringify(user));
    } else {
      // Supprimez du localStorage si l'utilisateur est null
      window.localStorage.removeItem("user");
    }
  }, [user]);

  useEffect(() => {
    if (!token) {
      const newToken = getCookie("token");
      if (newToken) {
        setToken(newToken);
      }
    }
  }, [token]);

  const users = useMemo(
    () => ({
      user,
      setUser,
      token,
      setToken,
      getUser,
    }),
    [user, token]
  );

  return <UserContext.Provider value={users}>{children} </UserContext.Provider>;
}

export default UserContextProvider;
